import React from 'react';
import { getFileTypeIconAsUrl } from '@fluentui/react-file-type-icons';

const SIZE = 24;

export const FileTypeIcon = ({ row }) => {
	const extension = String(row?.type ?? '')
		.toLowerCase()
		.replace(/^\./, '');
	const label = extension || 'File';

	const src = getFileTypeIconAsUrl({
		extension,
		size: SIZE,
		imageFileType: 'svg',
	});

	return <img src={src} alt={label} width={SIZE} height={SIZE} style={{ display: 'block' }} />;
};
